export const rewardImage = {
    'Meu primeiro UP':'/images/rewards/Conquista 1 - level.png',
    'Já não sou mais tão iniciante':'/images/rewards/Conquista 2 - level.png',
    'Nada como um pescador experiente':'/images/rewards/Conquista 3 - level.png',
    'A história viva de pescador':'/images/rewards/Conquista 4 - level.png',
    'O verdadeiro rei dos mares':'/images/rewards/Conquista 5 - level.png',

    'Meu primeiro peixe':'/images/rewards/Conquista 1 - AmountFish.png',
    'Levando o peixe das crianças':'/images/rewards/Conquista 2 - AmountFish.png',
    'Conhecido na cidade':'/images/rewards/Conquista 3 - AmountFish.png',
    'Conhecido na região':'/images/rewards/Conquista 4 - AmountFish.png',
    'Praticamente um showman da tv':'/images/rewards/Conquista 5 - AmountFish.png',

    'Ajudo com o que posso':'/images/rewards/Conquista 1 - buyParalleliums.png',
    'Amigo dos devs':'/images/rewards/Conquista 2 - buyParalleliums.png',
    'Uma pessoa de respeito':'/images/rewards/Conquista 3 - buyParalleliums.png',
    'Nós te amamos, sério!':'/images/rewards/Conquista 4 - buyParalleliums.png',
    'Todos os jogadores de Fishbay te agradecem':'/images/rewards/Conquista 5 - buyParalleliums.png',

    'Meu primeiro peixão':'/images/rewards/Conquista 1 - weightFish.png',
    'História de pescador':'/images/rewards/Conquista 2 - weightFish.png',
    'O homem do canal 4':'/images/rewards/Conquista 3 - weightFish.png',
    'Você é a própria pescaria':'/images/rewards/Conquista 4 - weightFish.png',
    'O ser mais forte da terra':'/images/rewards/Conquista 5 - weightFish.png',

    'Meu primeiro dinheirinho':'/images/rewards/Conquista 1 - achievedGold.png',
    'Pobre Plus':'/images/rewards/Conquista 2 - achievedGold.png',
    'O leite das crianças tá pago':'/images/rewards/Conquista 3 - achievedGold.png',
    'Guardando para não depender do INSS':'/images/rewards/Conquista 4 - achievedGold.png',
    'O verdadeiro Magnata da pescaria':'/images/rewards/Conquista 5 - achievedGold.png',
  };
  
  export const getItemImage = (itemName) => {
    return rewardImage[itemName] || rewardImage.default;
  };
  